<template lang="pug">
  app-dialog.breakword(v-model="$_show" :header="dialogDocHeader" :items="docItems")

    

</template>

<script>
import { AppDialogToggable } from "@/components"
import { config } from '@/_helpers'

export default {
  mixins: [AppDialogToggable],
  computed: {
    dialogDocHeader(){
      return 'Документ базы знаний' //+this.manageDoc.clause
    },

    docItems(){
      let items = [
        { icon: 'edit', title: 'Редактировать документ', action: () =>  this.showEditDoc() }
      ]
      if (this.manageDoc.fileExt && this.manageDoc.fileExt != '') items.push({ icon: 'file_copy', title: 'Открыть файл документа', action: () => this.loadFile() })

      items.push({ icon: 'delete', title: 'Удалить документ', action: () => this.showDelDoc() })
      return items
    }
  },

  methods: {

    $_beforeShow (doc) {
      this.manageDoc = doc
    },

    showEditDoc(){
      this.$emit('showDialogEditDoc',this.manageDoc)
    },

    showDelDoc(){
      this.$emit('showDialogDelDoc',this.manageDoc)
    },

    loadFile() {
      const link = document.createElement('a');
      link.href = config.apiUrl+'files/'+this.manageDoc.fileExt;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    

  },

  data () {
    return {
      manageDoc:{}
    }
  },
}
</script>